import { utag } from '../Tealium/Tealium';

const sendXhrRequest = (payload: Record<any, any>) => {
  const xhr = new XMLHttpRequest();
  xhr.open('POST', 'https://collect.tealiumiq.com/event');

  const transferComplete = function (evt: any) {
    if (xhr.status == 200) return;

    console.error('Could not log consent', xhr, evt);
  };

  const transferFailed = function () {
    console.error('An error occurred while sending consent.');
  };

  const transferCanceled = function () {
    console.error('The transfer has been cancelled by the user while sending the consent.');
  };

  xhr.addEventListener('load', transferComplete);
  xhr.addEventListener('error', transferFailed);
  xhr.addEventListener('abort', transferCanceled);

  xhr.send(JSON.stringify(payload));
};

export const logToTealium = (eventName: string, mapping: { [name: string]: string }, profile?: string): void => {
  const tealiumEventData: any = {
    tealium_account: utag?.data['tealium_account'],
    tealium_profile: profile?? utag?.data['tealium_eventstream_profile'] ?? utag?.data['tealium_profile'],
    tealium_visitor_id: utag?.data['cp.utag_main_v_id'],
    tealium_event: eventName,
    'ut.env': utag?.data['ut.env'],
    'ut.event': 'link',
    'currentUrl': window.location.href
  };

  for (const attribute in mapping) {
    tealiumEventData[attribute] = mapping[attribute];
  }

  sendXhrRequest(tealiumEventData);
};
